import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'redux-react-hook';
import { ColumnDiv } from 'styles/elements/div';
import { H1 } from 'styles/elements/headers';
import { Text } from 'styles/elements/text';
import { PrimaryButton, SecondaryButton } from 'styles/elements/buttons/primaryCare';
import { restartSession, extendSession } from 'redux/actions/session';
import media from 'styles/media';

const ResumeContainer = styled(ColumnDiv)`
  width: 100%;
  box-sizing: border-box;
  padding: 30px 12%;
  ${media.smallAndBelow`
    padding: 10px 3.5%;
  `}
`;

const ButtonContainer = styled.div`
  margin-top: 30px;
`;

export function Resume({ consultationStartTime, condition }) {
  const dispatch = useDispatch();
  return (
    <ResumeContainer>
      <H1>Resume consultation?</H1>
      <Text>Would you like to resume your consultation for {condition} started {consultationStartTime} ago?</Text>
      <ButtonContainer>
        <PrimaryButton onClick={() => dispatch(extendSession()).then(() => window.location.reload())}>Resume</PrimaryButton>
        <SecondaryButton onClick={() => dispatch(restartSession())}>Start over (your answers will be lost)</SecondaryButton>
      </ButtonContainer>
    </ResumeContainer>
  );
}
